import { decodeHtmlEntities } from 'js/helpers/data';

const transform = (articles) => {
  if (!articles || !articles.length) {
    return null;
  }

  return articles.map((article) => ({
    title: decodeHtmlEntities(article.title),
    description: decodeHtmlEntities(article.description),
    uri: article.link,
    imageUri: article.imageUrl,
  }));
};

export default transform;
